import React from "react"; // eslint-disable-line no-unused-vars
import { Rocket, Cloud, Zap, ArrowRight, Terminal, GitBranch, Server, Shield } from "lucide-react";
import './Home.css';

function Home() {
  return (
    <section id="home" className="home-section page-section">
      <div className="home-content">
        <div className="home-text">
          <div className="home-eyebrow">
            <span className="eyebrow-dot"></span>
            <span className="eyebrow-text">DevOps & Cloud Consulting</span>
          </div>

          <h1 className="home-title">
            We engineer the<br />
            infrastructure that<br />
            <span className="title-accent">powers growth.</span>
          </h1>

          <p className="home-subtitle">
            ILGI Tech Solutions delivers precision DevOps, cloud architecture,
            and software development. From CI/CD pipelines to Kubernetes at
            scale — we build the systems your business depends on.
          </p>

          <div className="home-buttons">
            <a href="#services" className="btn modern-btn btn-lg">
              Explore Services
              <ArrowRight size={18} />
            </a>
            <a href="#contact" className="btn modern-btn-outline btn-lg">
              Get in Touch
            </a>
          </div>

          <div className="key-features">
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true"><Rocket size={16} /></span>
              <span>DevOps Excellence</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true"><Cloud size={16} /></span>
              <span>Cloud Native</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true"><Zap size={16} /></span>
              <span>Rapid Delivery</span>
            </div>
          </div>
        </div>

        <div className="home-visual" aria-hidden="true">
          <div className="visual-panel">
            <div className="terminal-block">
              <div className="terminal-header">
                <div className="terminal-dots">
                  <span></span><span></span><span></span>
                </div>
                <span className="terminal-title">pipeline.yml</span>
              </div>
              <div className="terminal-body">
                <div className="code-line" style={{animationDelay: '0.2s'}}>
                  <span className="code-keyword">deploy</span>:
                </div>
                <div className="code-line" style={{animationDelay: '0.4s'}}>
                  &nbsp;&nbsp;<span className="code-prop">stage</span>: <span className="code-string">production</span>
                </div>
                <div className="code-line" style={{animationDelay: '0.6s'}}>
                  &nbsp;&nbsp;<span className="code-prop">strategy</span>: <span className="code-string">rolling</span>
                </div>
                <div className="code-line" style={{animationDelay: '0.8s'}}>
                  &nbsp;&nbsp;<span className="code-prop">replicas</span>: <span className="code-number">12</span>
                </div>
                <div className="code-line" style={{animationDelay: '1.0s'}}>
                  &nbsp;&nbsp;<span className="code-prop">health_check</span>: <span className="code-success">&#10003; passing</span>
                </div>
              </div>
            </div>

            <div className="metric-card metric-card-1">
              <Server size={16} />
              <div className="metric-info">
                <span className="metric-value">99.99%</span>
                <span className="metric-label">Uptime</span>
              </div>
            </div>

            <div className="metric-card metric-card-2">
              <GitBranch size={16} />
              <div className="metric-info">
                <span className="metric-value">2.4s</span>
                <span className="metric-label">Deploy Time</span>
              </div>
            </div>

            <div className="metric-card metric-card-3">
              <Shield size={16} />
              <div className="metric-info">
                <span className="metric-value">0</span>
                <span className="metric-label">Vulnerabilities</span>
              </div>
            </div>

            <div className="metric-card metric-card-4">
              <Terminal size={16} />
              <div className="metric-info">
                <span className="metric-value">CI/CD</span>
                <span className="metric-label">Automated</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
